import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as LoadingIcons from "react-loading-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteConfirmModal from "./DeleteConfirmModal";
import {
    deleteFacture,
    useGetFactures,
} from "../services/FactureService";
import {
    FaRegFileAlt,
    FaPaperPlane,
    FaCheckCircle,
    FaTimesCircle,
    FaHourglassEnd,
    FaExchangeAlt,
    FaList,
    FaEdit,
} from "react-icons/fa";
import { formatMoney } from "../utils/constante";
import { useSelector } from "react-redux";
import ActionDropdownFacture from "./ActionDropdownFacture";
import RelanceFacturePopup from "./RelanceFacturePopup";
import DateRangeInput from "./DateRangeInput";
import { saveAs } from "file-saver"; // npm install file-saver

const FacturesList = () => {
    const location = useLocation();
    const token = useSelector((state) => state.auth.token);
    const [pdfLoading, setPdfLoading] = useState(true);
    const [excelLoading, setExcelLoading] = useState(false);
    const [filterStatut, setFilterStatut] = useState("Tous");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [factureToDelete, setFactureToDelete] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null); // <-- ajout ici
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedFacture, setSelectedFacture] = useState(null);
    const [searchTermClient, setSearchTermClient] = useState("");
    const [searchTermNumeroFacture, setSearchTermNumeroFacture] = useState("");
    const handleOpenRelance = (facture) => {
        setSelectedFacture(facture);
        setOpenPopup(true);
    };
    const { factures, loading, pagination, page, setPage, fetchFactures, setDateRange, dateRange } = useGetFactures("Tous", {
        startDate: null,
        endDate: null
    });
    const navigate = useNavigate();
    useEffect(() => {
        fetchFactures(page, filterStatut, dateRange, searchTermClient, searchTermNumeroFacture);
    }, [page, filterStatut, dateRange, searchTermClient, searchTermNumeroFacture, fetchFactures]);

    // Détecte si un filtre est actif
    const isFilter = Boolean(
        searchTermClient.trim() !== "" ||
        searchTermNumeroFacture.trim() !== "" ||
        (dateRange.startDate && dateRange.endDate)
    );

    useEffect(() => {
        if (location.state?.message) {
            toast.success(location.state.message);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    // Mapping label <-> DB value
    const statutValues = {
        Tous: null,
        Brouillon: "brouillon",
        Envoyé: "envoye",
        Partiel: "partiel",
        Payée: "paye",
        "En retard": "retard",
        Annulé: "annule",
    };

    // Mapping API <-> affichage utilisateur
    const statutDisplay = {
        brouillon: "Brouillon",
        envoye: "Envoyé",
        partiel: "Partiel",
        paye: "Payée",
        retard: "En retard",
        annule: "Annulé",
        Tous: "Tous",
    };

    const statutStyles = {
        Tous: { bg: "bg-gray-700", icon: <FaList className="inline mr-1" /> },
        brouillon: { bg: "bg-gray-600", icon: <FaRegFileAlt className="inline mr-1" /> },
        envoye: { bg: "bg-blue-700", icon: <FaPaperPlane className="inline mr-1" /> },
        partiel: { bg: "bg-yellow-500", icon: <FaExchangeAlt className="inline mr-1" /> },
        paye: { bg: "bg-green-700", icon: <FaCheckCircle className="inline mr-1" /> },
        retard: { bg: "bg-red-500", icon: <FaHourglassEnd className="inline mr-1" /> },
        annule: { bg: "bg-red-700", icon: <FaTimesCircle className="inline mr-1" /> },
    };
    const statutStylesTelephone = {
        Tous: { bg: "bg-gray-700", icon: <FaList className="inline mr-1 " size={12} /> },
        brouillon: { bg: "bg-gray-600", icon: <FaRegFileAlt className="inline mr-1" size={12} /> },
        envoye: { bg: "bg-blue-700", icon: <FaPaperPlane className="inline mr-1" size={12} /> },
        partiel: { bg: "bg-yellow-500", icon: <FaExchangeAlt className="inline mr-1" size={12} /> },
        paye: { bg: "bg-green-700", icon: <FaCheckCircle className="inline mr-1" size={12} /> },
        retard: { bg: "bg-red-500", icon: <FaHourglassEnd className="inline mr-1" size={12} /> },
        annule: { bg: "bg-red-700", icon: <FaTimesCircle className="inline mr-1" size={12} /> },
    };
    const statutStylesTable = {
        Tous: { text: "text-gray-700", icon: <FaList className="inline mr-1" /> },
        brouillon: { text: "text-gray-600", icon: <FaRegFileAlt className="inline mr-1" /> },
        envoye: { text: "text-blue-700", icon: <FaPaperPlane className="inline mr-1" /> },
        partiel: { text: "text-yellow-500", icon: <FaExchangeAlt className="inline mr-1" /> },
        paye: { text: "text-green-700", icon: <FaCheckCircle className="inline mr-1" /> },
        retard: { text: "text-red-500", icon: <FaHourglassEnd className="inline mr-1" /> },
        annule: { text: "text-red-700", icon: <FaTimesCircle className="inline mr-1" /> },
    };

    const statuts = ["Tous", "brouillon", "envoye", "partiel", "paye", "retard", "annule"];

    const openPdf = (id) => {
        const pdfUrl = `http://localhost:8000/api/v1/factures/${id}/pdf?token=${token}`;
        console.log("PDF URL:", pdfUrl); // <-- ici on affiche l'URL dans la console
        setSelectedPdf(pdfUrl);
        setPdfLoading(true);
    };



    useEffect(() => {
        fetchFactures(page, filterStatut, dateRange, searchTermClient, searchTermNumeroFacture);
    }, [page, filterStatut, dateRange, searchTermClient, searchTermNumeroFacture, fetchFactures]);
    // Handler pour DateRangeInput
    const handleDateChange = ({ startDate, endDate }) => {
        setDateRange({ startDate, endDate });
    };
    const handleDeleteClick = (facture) => {
        setFactureToDelete(facture);
        setDeleteModalOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (!factureToDelete) return;
        try {
            const result = await deleteFacture(factureToDelete.id);
            toast.success(result.message);
            fetchFactures(page, filterStatut);
        } catch (err) {
            toast.error(err.message);
        } finally {
            setFactureToDelete(null);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.last_page) setPage(newPage);
    };

    const handleExportFacture = async () => {
        if (!dateRange.startDate || !dateRange.endDate) {
            toast.error("Veuillez choisir une période avant d’exporter");
            return;
        }
        setExcelLoading(true);
        // Convertir les objets Date en dd-mm-yyyy
        const formatDate = (d) => {
            const date = new Date(d);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${day}-${month}-${year}`; // dd-mm-yyyy
        };

        const dateDebut = formatDate(dateRange.startDate);
        const dateFin = formatDate(dateRange.endDate);

        const url = `http://localhost:8000/api/v1/factures/export-excel?date_debut=${dateDebut}&date_fin=${dateFin}&token=${token}`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                },
            });

            if (!response.ok) throw new Error("Erreur lors de l'export");
            setExcelLoading(false);

            const blob = await response.blob();
            saveAs(blob, `factures_${dateDebut}_to_${dateFin}.xlsx`);
        } catch (err) {
            console.error(err);
            setExcelLoading(false);
            toast.error("Impossible d’exporter le fichier Excel");

        }
    };
    const handleExportFactureToComptable = async () => {
        if (!dateRange.startDate || !dateRange.endDate) {
            toast.error("Veuillez choisir une période avant d’exporter");
            return;
        }
        setExcelLoading(true);

        // Convertir les objets Date en dd-mm-yyyy
        const formatDate = (d) => {
            const date = new Date(d);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        const dateDebut = formatDate(dateRange.startDate);
        const dateFin = formatDate(dateRange.endDate);

        const url = `http://localhost:8000/api/v1/factures/export-excel/parmail`;

        try {
            const response = await fetch(url, {
                method: "POST", // POST pour ton endpoint
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}` // token JWT dans header
                },
                body: JSON.stringify({
                    date_debut: dateDebut,
                    date_fin: dateFin
                })
            });

            const data = await response.json();

            setExcelLoading(false);

            if (!response.ok || !data.success) {
                toast.error(data.message || "Impossible d’exporter le fichier Excel");
                return;
            }

            toast.success(data.message); // message succès du backend
        } catch (err) {
            console.error(err);
            setExcelLoading(false);
            toast.error("Impossible d’exporter le fichier Excel");
        }
    };



    return (
        <section className="pb-4 flex flex-col gap-3 justify-center lg:px-4 px-2 w-full">
            <ToastContainer position="top-right" autoClose={3000} />
            <DeleteConfirmModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                clientName={factureToDelete?.numero}
            />
            {/* Loading général */}
            {excelLoading && (
                <div className="fixed inset-0 flex justify-center items-center z-[10] bg-white bg-opacity-85">
                    <div className="flex flex-col items-center">
                        <LoadingIcons.SpinningCircles
                            stroke="#1A2A6C"
                            fill="#1A2A6C"
                            strokeWidth={3}
                            height={50}
                            width={50}
                        />
                        <span className="mt-3 text-gray-800 font-medium">
                            Chargement...
                        </span>
                    </div>
                </div>
            )}

            {openPopup && (
                <RelanceFacturePopup
                    isOpen={openPopup}
                    onClose={() => setOpenPopup(false)}
                    facture={selectedFacture}
                    defaultMessage={
                        `Bonjour ${selectedFacture?.client?.nom_affichage},

J’espère que vous allez bien.

Je me permets de revenir vers vous concernant la facture ${selectedFacture?.numero}, émise le ${selectedFacture?.date_emission}, dont le règlement était prévu pour le ${selectedFacture?.date_echeance}.

À ce jour, sauf erreur de notre part, nous n’avons pas encore reçu votre règlement. Pourriez-vous, s’il vous plaît, nous confirmer la date prévue de paiement ?

Nous vous remercions par avance de votre retour.

Bien cordialement,  
${selectedFacture?.user?.nom_complet}  
${selectedFacture?.user?.nom_commercial}`
                    }
                    onSuccess={() => setOpenPopup(false)} // juste fermer le popup
                />
            )}



            {selectedPdf && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-transparent w-11/12 h-full rounded-lg shadow-lg p-2 relative">
                        <button
                            onClick={() => setSelectedPdf(null)}
                            className="absolute top-2 right-2 text-white bg-red-600 px-1 py-1/2 rounded"
                        >
                            X
                        </button>

                        {pdfLoading && (
                            <div className="flex justify-center items-center h-full">
                                <LoadingIcons.SpinningCircles
                                    stroke="#fff"
                                    fill="#fff"
                                    strokeWidth={3}
                                    height={40}
                                    width={40}
                                />
                                <span className="ml-3 text-white font-medium">
                                    Chargement du PDF...
                                </span>
                            </div>
                        )}

                        <iframe
                            src={selectedPdf}
                            title="Facture PDF"
                            className={`w-full h-full rounded-lg ${pdfLoading ? "hidden" : ""}`}
                            onLoad={() => setPdfLoading(false)}
                        />
                    </div>
                </div>
            )}

            {/* Titre + filtres + bouton */}
            <div className="flex lg:flex-row flex-col w-full lg:items-center items-start justify-between gap-2 py-2">

                <h1 className="font-bold font-Poppins lg:text-2xl text-xl text-color11 whitespace-nowrap">
                    Liste des Factures
                </h1>
                {/* Desktop : filtres + bouton Ajouter */}
                <div className="hidden lg:flex items-center gap-2">
                    <p className="text-sm font-bold font-Poppins">Filtrer par :</p>
                    {statuts.map((s) => {
                        const { bg, icon } = statutStyles[s];
                        const isActive = filterStatut === statutValues[s];
                        return (
                            <button
                                key={s}
                                onClick={() => setFilterStatut(statutValues[s])}
                                className={`flex items-center px-3 py-1 rounded-md text-xs font-semibold transition-colors duration-200 
                          ${isActive ? `${bg} text-white shadow-md` : `${bg} opacity-100 hover:opacity-80 text-white`}`}
                            >
                                {icon} {s === "Tous" ? "Tous" : statutDisplay[s]}
                            </button>
                        );
                    })}
                    <button
                        className="bg-color3 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center gap-1 text-xs"
                        onClick={() => navigate("/EspaceClient/facture/ajouter")}
                    >
                        <FaEdit /> Ajouter une Facture
                    </button>
                </div>

                {/* Mobile : bouton Ajouter */}
                <div className="lg:hidden flex justify-between w-full  items-start">
                    <p className="text-sm font-bold font-Poppins">Filtrer par :</p>
                    <button
                        className="bg-color3 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center gap-1 text-xs"
                        onClick={() => navigate("/EspaceClient/facture/ajouter")}
                    >
                        <FaEdit size={15} /> Ajouter une facture
                    </button>
                </div>

                {/* Mobile : filtres scrollables */}
                <div className="lg:hidden flex overflow-x-auto w-screen gap-2 py-3">
                    {statuts.map((s) => {
                        const { bg, icon } = statutStylesTelephone[s];
                        const isActive = filterStatut === statutValues[s];
                        return (
                            <button
                                key={s}
                                onClick={() => setFilterStatut(statutValues[s])}
                                className={`flex items-center justify-center px-3 py-1 rounded-md text-xs font-semibold transition-colors duration-200
                          ${isActive ? `${bg} text-white shadow-md` : `${bg} opacity-100 hover:opacity-80 text-white`}`}
                            >
                                {icon} {s === "Tous" ? "Tous" : statutDisplay[s]}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="flex flex-row w-full  items-center flex-1 gap-2">
                <input
                    type="text"
                    placeholder="Filtrer par numero du facture ..."
                    className="flex-1 px-4 py-2 border border-color1 rounded-md focus:outline-none focus:ring-2 focus:ring-color1 focus:border-color1"
                    value={searchTermNumeroFacture} // lie l'input à l'état searchTerm
                    onChange={(e) => setSearchTermNumeroFacture(e.target.value)} // met à jour searchTerm à chaque frappe
                />
                <input
                    type="text"
                    placeholder="Filtrer par nom du client ..."
                    className="flex-1 px-4 py-2 border border-color1 rounded-md focus:outline-none focus:ring-2 focus:ring-color1 focus:border-color1"
                    value={searchTermClient} // lie l'input à l'état searchTerm
                    onChange={(e) => setSearchTermClient(e.target.value)} // met à jour searchTerm à chaque frappe
                />

            </div>
            <div className="flex lg:flex-row flex-col w-full ">
                <DateRangeInput
                    initialStartDate={dateRange.startDate}
                    initialEndDate={dateRange.endDate}
                    onChange={handleDateChange}
                    title2="Filtrer par Date Émission : "
                />

                <div className="flex lg:flex-row items-end justify-end gap-2">
                    {isFilter && (
                        <p
                            onClick={() => {
                                setSearchTermClient("");
                                setSearchTermNumeroFacture(""); // corrigé ici
                                setDateRange({ startDate: null, endDate: null });
                                handlePageChange(1); // on revient à la première page
                            }}
                            className="cursor-pointer w-auto rounded-full px-4 py-2 text-color1"
                        >
                            Réinitialiser
                        </p>
                    )}
                    <div className="flex flex-row  items-center justify-center gap-1 ">

                        <p
                            onClick={handleExportFactureToComptable}
                            className="bg-color23 rounded-full w-auto items-center justify-center flex text-white px-4 py-1   cursor-pointer transition whitespace-nowrap text-center"
                        >
                            Envoyer au comptable
                        </p>
                        {/* Section Exporter Facture */}
                        <p
                            onClick={handleExportFacture}
                            className="bg-color1 rounded-full w-full text-white px-4 py-1 hover:bg-color3 cursor-pointer transition whitespace-nowrap text-center"
                        >
                            Télécharger Excel
                        </p>
                    </div>


                </div>



            </div>
            {/* Tableau */}
            <div className="relative overflow-x-auto shadow-md rounded-xl border border-gray-200 bg-white">
                <table className="w-full text-sm text-left border-collapse">
                    <thead className="bg-color1 text-color2 uppercase text-xs font-semibold">
                        <tr>
                            <th className="px-3 py-2 w-[40px] text-center">#</th>
                            <th className="px-3 py-2 w-[120px] text-center">Numéro</th>
                            <th className="px-3 py-2 w-[150px] text-center">Client</th>
                            <th className="px-3 py-2 w-[120px] text-center">Date émission</th>
                            <th className="px-3 py-2 w-[120px] text-center">Échéance</th>
                            <th className="px-3 py-2 w-[120px] text-center">Statut</th>
                            <th className="px-3 py-2 w-[120px] text-center">Total HT</th>
                            <th className="px-3 py-2 w-[100px] text-center">Remise</th>
                            <th className="px-3 py-2 w-[100px] text-center">TVA</th>
                            <th className="px-3 py-2 w-[120px] text-center">Total TTC</th>
                            <th className="px-3 py-2 w-[160px] text-center">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="11" className="h-[450px] text-center">
                                    <div className="flex justify-center items-center">
                                        <LoadingIcons.SpinningCircles
                                            stroke="#2218eeff"
                                            fill="#2218eeff"
                                            strokeWidth={3}
                                            height={40}
                                            width={40}
                                        />
                                        <span className="ml-3 text-gray-600 font-medium">
                                            Chargement des factures...
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ) : factures && factures.length > 0 ? (
                            factures.map((f, index) => (
                                <tr key={f.id} className={`border-b hover:bg-gray-100 transition ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                                    <td className="px-3 py-3 text-center font-medium text-gray-700">
                                        {index + 1 + (pagination.current_page - 1) * pagination.per_page}
                                    </td>
                                    <td className="px-3 py-3 text-center">{f.numero}</td>
                                    <td className="px-3 py-3 text-center">{f.client?.nom_affichage || "-"}</td>
                                    <td className="px-3 py-3 text-center">{f.date_emission || "-"}</td>
                                    <td className="px-3 py-3 text-center">{f.date_echeance || "-"}</td>
                                    <td className="px-3 py-3 text-center">
                                        <span className={`flex items-center justify-center font-semibold ${statutStylesTable[f.statut]?.text}`}>
                                            {statutStylesTable[f.statut]?.icon} {statutDisplay[f.statut] || f.statut}
                                        </span>
                                    </td>
                                    <td className="px-3 py-3 text-center">{formatMoney(f.sous_total_centimes, f.devise)}</td>
                                    <td className="px-3 py-3 text-center">{formatMoney(f.remise_centimes, f.devise)}</td>
                                    <td className="px-3 py-3 text-center">{formatMoney(f.tva_centimes, f.devise)}</td>
                                    <td className="px-3 py-3 text-center font-bold">{formatMoney(f.total_centimes, f.devise)}</td>
                                    <td className="px-3 py-3 text-center relative z-20">
                                        <ActionDropdownFacture
                                            f={f}
                                            navigate={navigate}
                                            handleDeleteClick={handleDeleteClick}
                                            openPdf={openPdf}
                                            isOpen={openDropdownId === f.id}
                                            onToggle={() => setOpenDropdownId(openDropdownId === f.id ? null : f.id)}
                                            onClose={() => setOpenDropdownId(null)}
                                            openRelance={handleOpenRelance} // <-- ici

                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="11" className="py-4 text-center text-gray-500">
                                    Aucune facture trouvée.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex w-full justify-center items-center gap-3 mt-4">
                <button
                    disabled={pagination.current_page === 1}
                    onClick={() => handlePageChange(pagination.current_page - 1)}
                    className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === 1
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-color1 hover:bg-color6 cursor-pointer"
                        }`}
                >
                    Précédent
                </button>
                <span className="text-color11 font-medium text-sm">
                    {pagination.current_page} / {pagination.last_page}
                </span>
                <button
                    disabled={pagination.current_page === pagination.last_page}
                    onClick={() => handlePageChange(pagination.current_page + 1)}
                    className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === pagination.last_page
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-color1 hover:bg-color6 cursor-pointer"
                        }`}
                >
                    Suivant
                </button>
            </div>
        </section>
    );
};

export default FacturesList;
